import React from "react"

import LifestyleTopicsPage from "../../../components/pageComponents/Ask/Lifestyle/LifestyleTopicsPage"

const Lifestyle = () => {
  return <LifestyleTopicsPage />
}

export default Lifestyle
